<template>
    <PageHeader :title="Title" :breadcrumb-list="BreadcrumbList" class="sec-banner">
          <template #content>
              <p>{{ Desc }}</p>
          </template>
      </PageHeader>
</template>

<script>
export default {
  name: 'HeaderSec',
  components: {
  },
  props: {
    Title: {
        type: String,
        default: "超融合",
    },
    BreadcrumbList: {
        type: Array,
        default: [
            {
                title: '首页',
                to: '/'
            },
            {
                title: '云与基础设施',
                to: '/Blueiaas'
            },
            {
                title: '超融合'
            }
        ],
    },
    Desc: {
        type: String,
        default: "超融合",
    }
  },
  setup() {
  },
  data(){
    return {}
  },
  methods: {
    handleClick() {}
  }
}
</script>

<style lang="less" scoped>
.sec-banner{
  color: lightcoral;
  font-size: @font-size;
  margin: 0 0 20px 0;
  width: 99%;
  border-bottom: none;
}
@media (min-width: 1000px) {
  .sec-banner{
    width: 1600px;
    border-bottom: none;
  }
}
</style>
